import React from 'react';
import ContactForm from './ContactForm';

const Contact = () => {
  return (
    <ContactForm
      variant="site"
      title="Contattaci"
      description="Siamo a tua disposizione per rispondere a tutte le tue domande e richieste."
    />
  );
};

export default Contact;
